import { z } from 'zod';
export const InvoiceStatus = z.enum([
    'draft',
    'open',
    'paid',
    'failed',
    'refunded',
    'void',
]);
// Money is carried as decimal strings end-to-end to avoid float drift,
// mirroring numeric(12,2) DB columns and the pricing surface.
const Money = z.string().regex(/^-?\d+(\.\d{1,2})?$/, 'Must be a decimal amount');
export const InvoiceLineItemSchema = z.object({
    description: z.string().min(1),
    quantity: z.number().int().positive(),
    unitAmount: Money,
    amount: Money,
});
export const CreateInvoiceSchema = z.object({
    orderId: z.string().uuid().optional(),
    lineItems: z.array(InvoiceLineItemSchema).min(1),
    tax: Money.optional(),
    dueDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    notes: z.string().max(2000).optional(),
});
